import Vue from 'vue'
import store from '@/store'
import Router from 'vue-router'

import Dashboard from './../views/Dashboard.vue'
import Login from './../views/Login.vue'
import Logout from './../views/Logout.vue'
import Play from './../views/Play.vue'
import PagePlay from './../views/PagePlay.vue'
import Signout from './../views/Signout.vue'
import NotFound from './../views/NotFound.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'dashboard',
    //   component: Dashboard,
    //   meta: {
    //     layout: 'default',
    //     guarded: true
    //   }
    // },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: Login,
    //   beforeEnter (from, to, next) {
    //     next(store.state.token === '' ? true : {name: 'dashboard'})
    //   },
    //   meta: {
    //     layout: 'login',
    //     guarded: false
    //   }
    // },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
      meta: {
        guarded: true
      }
    },
     {
      path: '/play',
      name: 'play',
      component: Play,
      meta: {
        layout : 'play',
        guarded: false
      }
    },
    {
      path: '/',
      name: 'pageplay',
      component: PagePlay,
      meta: {
        layout : 'play',
        guarded: true
      }
    },
    {
      path: '/pageplay',
      name: 'pageplay',
      component: PagePlay,
      meta: {
        layout : 'play',
        guarded: true
      }
    },
     {
      path: '/signout',
      name: 'signout',
      component: Signout,
      meta: {
        layout : 'play',
        guarded: true
      }
    },
    {
      path: '/*',
      component: NotFound
    }
  ]
})

router.beforeEach((to, from, next) => {

    next(
      (to.fullPath === '/' && to.meta.guarded && store.state.token === '') ? {name: 'play'} : true
    )
    /*
    if (to.fullPath === '/dashboard') {
      if(to.meta.guarded && store.state.token === ''){
        next('/login');
      }
    }*/

   /* if (to.fullPath === '/pageplay') {
      if(to.meta.guarded && store.state.playerToken === ''){
        next('/play');
      }
    }*/
    //next();

  })

export default router